import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const StyledImg = styled.img`
  max-height: 100%;
`;

type ProductPreviewProps = {
  api_key?: string;
  personalization_id?: string;
  previewData: any;
  isLoading: boolean;
  error: unknown
}

export const ProductPreview: React.FC<ProductPreviewProps> = ({ error, isLoading, previewData, api_key, personalization_id }) => {
  const [imageUrl, setImageUrl] = useState<string>();
  const { t } = useTranslation()

  useEffect(() => {
      //console.log("ProductPreview ", JSON.stringify(previewData))
      var colorImageId='',viewName='',colorName='',targetImageId='';

      //return if no selected color image id
      if (!previewData?.data?.selected_color_image_id) { 
        return; 
      }
      colorImageId = previewData?.data?.selected_color_image_id;
      //find View Name by Selected Color Image Id
      previewData.data.product.view_list?.forEach((view: any) => {
        view.color_list?.forEach((color: any) => {
            color.design_list?.forEach((design: any) => {
              if(design.personalization_id === personalization_id){
                viewName = view.name;
              }
            });
        });
      });
      //Now find the color name by colorname image id
      previewData.data.product.blank.images?.forEach((img: any) => {
        if(img.id === colorImageId){
          colorName = img.color_name;
        }
      });
      previewData.data.product.blank.images?.forEach((img: any) => {
        if(img.view_name === viewName && img.color_name===colorName){
          targetImageId = img.id;
        }
      });

      console.log('colorImageId:', colorImageId);
      console.log('viewName: ', viewName);
      console.log('colorName: ', colorName);
      console.log('targetImageId: ', targetImageId);
      var targetImg = previewData?.data?.previews.find((item: any) => {return item.image_id === targetImageId && item.name === "500"});

      if(!targetImg){
        targetImg = previewData?.data?.previews.find((item: any) => {return item.image_id === previewData?.data?.selected_color_image_id && item.name === "500"});
      }
      if (targetImg) {
        console.log("targetImg:", targetImg.url)
        setImageUrl(targetImg.url);  // set the url
      }
  }, [previewData]);
  // Handle loading and errors
  if (isLoading) {
    return <p>{t("preview.loading")}</p>;
  }

  if (error) {
    return <p>{t("preview.error")} {(error as Error).message}</p>;
  }

  return (<>

    <StyledImg src={imageUrl} alt={previewData?.file_name} />
  </>)
};
